import { connect } from "react-redux";
import withSignalGetter from "./with-signal-getter";
import compose from "../utils/compose";

import { changeWholeGraphSettings } from "../redux/actions/report-actions";

const mapStateToProps = ({
    reportApp: {
        reportData: {
            report: {
                complexes,
                signal: { fd, channelNames, signalLength, reportFragmStart_pnt }
            },

            settings: {
                graphs: {
                    graph12Leads: { start_pnt: graph12LeadStart_pnt },
                    wholeECGGraph: defaultScale,
                    wholeECGGraphRhythm: rhythmScale,
                    graph12Leads
                }
            }
        }
    }
}) => {
    return {
        defaultScale,
        rhythmScale,
        graph12Leads,
        graph12LeadStart_pnt,
        fd,
        signalLength,
        channelNames,
        complexes,
        reportFragmStart_pnt
    };
};

const mapDispatchToProps = {
    changeWholeGraphSettings
};

export const prepareSplitHOC = component => {
    return compose(withSignalGetter, connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true }))(component);
};
